import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IBarContainerProps {
  height?: number;
};

export const Root = styled.div`
  min-height: 122px;
  display: flex;
  flex-direction:column; 
  padding: 0px 64px;
`;


export const optionContainer = styled.div`
  display:flex;
  flex-direction:row;  
  align-items: center;
  margin-top:10px;
  width:100%;
`;

export const radioContainer = styled.div`
  display:flex;
  margin-top:10px;
  padding: 0 0 24px 0;  
  width:100%;
`;


export const Label = styled.div`
  display:flex;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  margin:6px 10px 10px 0px;
  width:200px;
`;



export const titleContainer = styled.div`
  display:flex;
  flex-direction:column;  
  margin: 30px 10px 25px 0px;
  
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
`;

export const buttonContainer = styled.div`
  display:flex;
  flex-direction:column;  
  align-items: baseline;
  margin:10px 0 20px 0;
  width:100%;
`;

export const SliderContainer = styled.div`
  display:flex;  
  width:100%;  
`;


export const SliderTextContainer = styled.div`
  display:flex;  
  width:100%;  
  flex-direction:row;
  align-items:center;
  justify-content: space-between;
`;


export const InputSlider = styled.input `
  width: 40px;
  height: 18px;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  background-color: var(--white);
  text-align: center;
  margin:10px;
  margin-right:0px;
  outline: none;
`;


export const LabelSize = styled.div`
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #8891a0;   
    margin-right:15px;
`;

export const LabelCompress = styled.div`
    font-family: Roboto;    
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #122442;
    margin-top:25px;  
`;

export const CompressContainer = styled.div`
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 9px;
`;